export const OVERNIGHT_CAMP_ASSOCIATION_LIST_SUCCESS =
  'OVERNIGHT_CAMP_ASSOCIATION_LIST_SUCCESS';
export const OVERNIGHT_CAMP_ASSOCIATION_LIST_FAILURE =
  'OVERNIGHT_CAMP_ASSOCIATION_LIST_FAILURE';

export const OVERNIGHT_CAMP_YEAR_LIST_SUCCESS =
  'OVERNIGHT_CAMP_YEAR_LIST_SUCCESS';
export const OVERNIGHT_CAMP_YEAR_LIST_FAILURE =
  'OVERNIGHT_CAMP_YEAR_LIST_FAILURE';
